import * as React from 'react'
import Paper from '@mui/material/Paper'
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined'
import { useHandlers } from './hooks'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

export function EmptyStub() {
  const { handleCreateClick } = useHandlers()

  return (
    <Paper>
      <Stack p={3} alignItems="center" width={360}>
        {/* This is a 72x72 layout box; the Material glyph only fills 20 of its
            24 viewBox units, so the painted icon is ~54x60 — matching the
            51x62 icon it replaces. The taller box adds ~10px of space above
            the heading, which is accepted rather than worked around. */}
        <AssignmentOutlined color="primary" sx={{ fontSize: 72 }} />
        <Typography variant="h6" my={2.4}>
          Activities
        </Typography>
        <Typography
          variant="body2"
          mb={6}
          textAlign="center"
          letterSpacing={0.15}
        >
          Create custom activities for employees to track and manage key events.
          Activity history is automatically aggregated and available for
          reporting.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleCreateClick}
          fullWidth
        >
          Create Activity Type
        </Button>
      </Stack>
    </Paper>
  )
}
